import { push } from "@lagunovsky/redux-react-router";
import { ROUTES } from "../../libs";
import { AsyncAppThunk } from "../application-state";
import { clearLoginData } from "./login";
import { CustomizedPush } from "store/navigation-wrapper";

export const logout = (): AsyncAppThunk => async (dispatch) => {
  dispatch(clearLoginData());
  CustomizedPush(ROUTES.LOGIN);
};
